export const DOSSIER_GROUPING_QUERY_PARAM = 'grouping';
export const WORK_STATUS_QUERY_PARAM = 'workStatus';
export const VEHICLE_STATUS_QUERY_PARAM = 'vehicleStatus';